import Icon1 from "@assets/icons/Icon";
import { showNotification } from "context/notification.service";
import { useState } from "react";
import { colors } from "sexy";
type Option = {
  label: string;
  value: string;
};
const data = [
  { label: "Création", value: "17/10/2025" },
  { label: "Activité", value: "15/12/2025 Il y a 13 jours" },
  { label: "Email", value: "marie.curie@life.com" },
  { label: "Tel", value: "07 58 96 35 21" },
];

export const CopiableInfosSection = ({
  options = data,
  width = " w-100 ",
}: {
  options?: Option[];
  width?: string;
}) => {
  const [copied, setCopied] = useState<string>("");
  return (
    <div className="flex flex-col text-h2 ">
      {options.map((item, index) => (
        <div
          key={index}
          className="flex flex-row  items-center text-neutral-400 "
        >
          <div className={`${width}`}>{item.label}</div>
          <div
            onClick={() => {
              console.log("copying");
              navigator.clipboard.writeText(item.value);
              showNotification({
                type: "success",
                message: `${item.label} copié dans le presse-papier !`,
              });
              setCopied(item.label);
              setTimeout(() => setCopied(""), 300);
            }}
            style={{
              paddingTop: 1,
            }}
            className={`
                ${copied === item.label ? " border-green-300" : "border-transparent hover:border-neutral-200"}
                flex flex-row items-center group gap-2 transition-all duration-200 px-2 pt-0.5 cursor-pointer border-2  outline-none rounded-lg `}
          >
            {item.value}
            <div className="group-hover:rotate-0 group-hover:opacity-100 opacity-0 rotate-180 transition-all duration-500">
              <Icon1
                animated={true}
                name="copy"
                size={copied === item.label ? 26 : 20}
                color={
                  copied === item.label ? colors.green_400 : colors.neutral_300
                }
              ></Icon1>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
